import styled, { css, keyframes } from "styled-components";
import { backdropBlurFilter } from "../utils/backdropblur";
export const Subtitle = styled.span `
  font-weight: ${({ fontWeight }) => fontWeight};
`;
const slideUpKeyFrames = keyframes `
  from {
    top: 100%;
  }
      
  to {
    top: 35%;
  }
`;
const slideDownKeyFrames = keyframes `
  from {
    top: 0%;
  }
      
  to {
    top: 65%;
  }
`;
const opacityKeyFrames = (opacity) => keyframes `
  0% {
    opacity: 0; 
  }
  100% {
    opacity: ${opacity};
  }
`;
const animateFadeIn = (position) => css `
  ${position === "bottom" ? slideDownKeyFrames : slideUpKeyFrames}
`;
const animateOpacity = (opacity) => () => css `
    ${opacityKeyFrames(opacity)}
  `;
export const StyledContentBox = styled.div `
  ${({ theme, color, animation }) => !animation
    ? backdropBlurFilter(4, color === "white"
        ? theme.colors.transparentWhite
        : theme.colors.transparentBlack, color === "white" ? 0.8 : 0.7, color === "white" ? 0.9 : 0.8)
    : ""}

  backdrop-filter: blur(0.25rem);
  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: ${({ color, theme, animation }) => animation
    ? `rgb(${color === "white"
        ? theme.colors.transparentWhite
        : theme.colors.transparentBlack})`
    : ""};

    ${({ animation, color }) => animation
    ? css `
            animation: ${animateOpacity(color === "white" ? 0.8 : 0.7)} 1.5s
              ease-in both;
          `
    : ""}

    @-moz-document url-prefix() {
      ${({ animation, color }) => animation
    ? css `
              animation: ${animateOpacity(color === "white" ? 0.9 : 0.8)} 1.5s
                ease-in both;
            `
    : ""}
    }
  }

  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: min-content;
  position: relative;
  top: ${({ position, animation }) => animation ? "" : position === "top" ? "35%" : "65%"};
  transform: translateY(
    ${({ position }) => (position === "top" ? "-35%" : "-65%")}
  );
  color: ${({ color, theme }) => color === "white" ? theme.colors.black : theme.colors.white};
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  z-index: 15;

  ${({ animation, position }) => animation
    ? css `
          animation: ${animateFadeIn(position)} 1.5s ease-in both;
        `
    : ""}

  @media ${({ theme }) => theme.device.medium} {
    padding: 1.5rem 2rem;
  }

  && h1,
  && h2 {
    max-width: 100%;
    z-index: 1;
    white-space: break-spaces;
    word-wrap: break-word;
    word-break: break-word;
    margin-bottom: 0;
    margin-top: 0;

    span {
      display: block;
      max-width: 100%;
      white-space: break-spaces;
      word-wrap: break-word;
      word-break: break-word;
      text-transform: uppercase;
    }
  }

  button {
    align-self: flex-end;
    z-index: 1;
    border: 1px solid
      ${({ theme, color }) => (color === "black" ? theme.colors.white : "")};
    margin-top: 1.5rem;

    @media ${({ theme }) => theme.device.medium} {
      margin-top: 3rem;
    }
  }
`;
